import { Stays, Profile, Tickets, TripPacks, Wishlist, Experiences, TripPackResult, TicketsAirplane, About, Trips, Booking, TripItinerary } from "pages";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import { routes } from "utils";

const Navigator = () => {
  return (
      <Switch>
        <Route exact path="/">
          <Redirect to={routes.PACKAGES.INDEX} /> 
        </Route>
        <Route
          exact
          path={routes.PACKAGES.INDEX}
          component={withRouter(TripPacks)}
        />
        <Route
          path={routes.WISHLIST.INDEX}
          component={withRouter(Wishlist)}
        />
        <Route
          path={routes.STAYS.INDEX}
          component={withRouter(Stays)}
        />
         <Route
          path={routes.TICKETS.INDEX}
          component={withRouter(Tickets)}
        />
         <Route
          path={routes.EXPERIENCES.INDEX}
          component={withRouter(Experiences)}
        />
        <Route
          path={routes.PACKAGES.TRIP_PACK_RESULTS}
          component={withRouter(TripPackResult)}
        />
        <Route
          path={routes.STAYS.STAYS_RESULTS}
          component={withRouter(TripPackResult)}
        />
        <Route
         path={routes.TICKETS.AIRPLANE}
         component={withRouter(TicketsAirplane)}
       />
        <Route
          path={routes.ABOUT.INDEX}
          component={withRouter(About)}
        />
        <Route
          path={routes.PROFILE.INDEX}
          component={withRouter(Profile)}
        />
        <Route
          path={routes.PROFILE.TRIPS}
          component={withRouter(Trips)}
        />
        <Route
          path={routes.PROFILE.TRIP_ITINERARY}
          component={withRouter(TripItinerary)}
        />
        <Booking />
      </Switch>
  );
}

export { Navigator};